module.exports = __webpack_public_path__ + "img/icon-warning-stormflo-3.5f7a15d4.svg";